import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { MainCategory } from '../../interfaces/routering/main-category';

@Injectable()

export class MainCategoryService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(head_category_id: number): Observable<MainCategory[] | boolean> {
    return new Observable<MainCategory[] | boolean>((o: Subscriber<MainCategory[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.main-categories.index', {':head_category_id': head_category_id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<MainCategory[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(head_category_id: number, id: number): Observable<MainCategory | boolean> {
    return new Observable<MainCategory | boolean>((o: Subscriber<MainCategory | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.main-categories.read', {':head_category_id': head_category_id, ':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<MainCategory>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(head_category_id: number, formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('routering.main-categories.create', {
      ':head_category_id': head_category_id
    }), formData);
  }

  update(head_category_id: number, id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('routering.main-categories.update', {
      ':head_category_id': head_category_id,
      ':id': id
    }), formData);
  }

  delete(head_category_id: number, id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('routering.main-categories.delete', {':head_category_id': head_category_id, ':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  restore(head_category_id: number, id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('routering.main-categories.restore', {':head_category_id': head_category_id, ':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
